import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchClientData,
  plannedVideoStore,
} from "../../features/commonSlice/commonSlice";

const AddNewClients = () => {
  const initialFormData = {
    clientName: "",
    clientId: null,
    platform: "",
    channelLink: "",
    genre: "",
    language: "",
    subscribers: "",
    dealType: "",
    liveDate: "",
    smbSnmb: "",
    product: "",
    videoStatus: "",
    videoUrl: "",
    channelName: "",
    liveTime: "",
    descriptionUrl: "",
    views: "",
    likes: "",
    comments: "",
    clicks: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [clientList, setClientList] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientData } = useSelector((state) => state.influencer);

  // Fetch client data
  useEffect(() => {
    dispatch(fetchClientData());
  }, [dispatch]);

  // Use API response directly
  useEffect(() => {
    if (clientData?.data) {
      setClientList(clientData.data); // already [{ label, value }]
    } else {
      setClientList([]);
    }
  }, [clientData]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      client_name: formData.clientName, // label
      client_id: formData.clientId, // value
      platform: formData.platform,
      channel_link: formData.channelLink,
      genre: formData.genre,
      language: formData.language,
      subscribers: formData.subscribers,
      deal_type: formData.dealType,
      live_date: formData.liveDate,
      smb_snmb: formData.smbSnmb,
      product: formData.product,
      video_status: formData.videoStatus,
      video_url: formData.videoUrl,
      channel_name: formData.channelName,
      live_time: formData.liveTime,
      description_url: formData.descriptionUrl,
      views: formData.views,
      likes: formData.likes,
      comments: formData.comments,
      clicks: formData.clicks,
    };

    dispatch(plannedVideoStore(payload))
      .unwrap()
      .then((res) => {
        toast.success("Form submitted successfully!");
        setFormData(initialFormData);
      })
      .catch((err) => {
        console.error("Submit error:", err);
        toast.error("Something went wrong, please try again.");
      });
  };

  const handleReset = () => setFormData(initialFormData);

  return (
    <form className="tablelist-form" autoComplete="off" onSubmit={handleSubmit}>
      <div className="modal-body">
        <div className="row g-3">
          {/* Client Name */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="clientName" className="form-label">
              Client Name <span className="text-danger">*</span>
            </label>
            <Select
              id="clientName"
              options={clientList}
              value={clientList.find((c) => c.value === formData.clientId) || null}
              onChange={(selected) =>
                setFormData({
                  ...formData,
                  clientName: selected ? selected.label : "",
                  clientId: selected ? selected.value : null,
                })
              }
              placeholder="Select Client"
              isClearable
            />
          </div>

          {/* Platform */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="platform" className="form-label">
              Platform
            </label>
            <select
              id="platform"
              className="form-select mb-3"
              value={formData.platform}
              onChange={handleChange}
            >
              <option value="">Select Platform</option>
              <option value="Youtube">Youtube</option>
              <option value="Instagram">Instagram</option>
              <option value="Facebook">Facebook</option>
            </select>
          </div>

          {/* Channel Link */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="channelLink" className="form-label">
              Channel Link
            </label>
            <input
              type="text"
              id="channelLink"
              className="form-control"
              placeholder="Enter Channel URL"
              value={formData.channelLink}
              onChange={handleChange}

            />
          </div>

          {/* Genre */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="genre" className="form-label">
              Genre
            </label>
            <select
              id="genre"
              className="form-select mb-3"
              value={formData.genre}
              onChange={handleChange}
            >
              <option value="">Select Genre</option>
              <option value="Entertainment">Entertainment</option>
              <option value="Infotainment">Infotainment</option>
              <option value="Content Creator">Content Creator</option>
            </select>
          </div>

          {/* Language */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="language" className="form-label">
              Language
            </label>
            <select
              id="language"
              className="form-select mb-3"
              value={formData.language}
              onChange={handleChange}
            >
              <option value="">Select Language</option>
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Subscribers */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="subscribers" className="form-label">
              Subscribers
            </label>
            <input
              type="number"
              id="subscribers"
              className="form-control"
              placeholder="Enter Subscribers"
              value={formData.subscribers}
              onChange={handleChange}
            />
          </div>

          {/* Deal Type */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="dealType" className="form-label">
              Deal Type
            </label>
            <select
              id="dealType"
              className="form-select mb-3"
              value={formData.dealType}
              onChange={handleChange}
            >
              <option value="">Select Deal Type</option>
              <option value="Video">Video</option>
              <option value="CPA">CPA</option>
            </select>
          </div>

          {/* Live Date */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="liveDate" className="form-label">
              Live Date
            </label>
            <input
              type="date"
              id="liveDate"
              className="form-control"
              value={formData.liveDate}
              onChange={handleChange}

            />
          </div>

          {/* SMB/SNMB */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="smbSnmb" className="form-label">
              SMB/SNMB
            </label>
            <select
              id="smbSnmb"
              className="form-select mb-3"
              value={formData.smbSnmb}
              onChange={handleChange}
            >
              <option value="">Select SMB/SNMB</option>
              <option value="SMB">SMB</option>
              <option value="SNMB">SNMB</option>
            </select>
          </div>

          {/* Product */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="product" className="form-label">
              Product
            </label>
            <select
              id="product"
              className="form-select mb-3"
              value={formData.product}
              onChange={handleChange}
            >
              <option value="">Select Product</option>
              <option value="Term">Term</option>
              <option value="Health">Health</option>
              <option value="Travel">Travel</option>
            </select>
          </div>

          {/* Video Status */}
          <div className="col-lg-6 mt-2">
            <label htmlFor="videoStatus" className="form-label">
              Video Status
            </label>
            <select
              id="videoStatus"
              className="form-select mb-3"
              value={formData.videoStatus}
              onChange={handleChange}
            >
              <option value="">Select Video Status</option>
              <option value="Plan">Plan</option>
              <option value="Live">Live</option>
            </select>
          </div>

          {/* Show live video fields only if status is Live */}
          {formData.videoStatus === "Live" && (
            <>
              <div className="col-lg-6 mt-2">
                <label htmlFor="videoUrl" className="form-label">
                  Video URL
                </label>
                <input
                  type="text"
                  id="videoUrl"
                  className="form-control"
                  placeholder="Enter Video URL"
                  value={formData.videoUrl}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mt-2">
                <label htmlFor="channelName" className="form-label">
                  Channel Name
                </label>
                <input
                  type="text"
                  id="channelName"
                  className="form-control"
                  placeholder="Enter Channel Name"
                  value={formData.channelName}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mt-2">
                <label htmlFor="liveTime" className="form-label">
                  Live Time
                </label>
                <input
                  type="time"
                  id="liveTime"
                  className="form-control"
                  value={formData.liveTime}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mt-2">
                <label htmlFor="descriptionUrl" className="form-label">
                  Description URL
                </label>
                <input
                  type="text"
                  id="descriptionUrl"
                  className="form-control"
                  placeholder="Enter Description URL"
                  value={formData.descriptionUrl}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mt-2">
                <label htmlFor="views" className="form-label">
                  Views
                </label>
                <input
                  type="number"
                  id="views"
                  className="form-control"
                  placeholder="Enter Views"
                  value={formData.views}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mt-2">
                <label htmlFor="likes" className="form-label">
                  Likes
                </label>
                <input
                  type="number"
                  id="likes"
                  className="form-control"
                  placeholder="Enter Likes"
                  value={formData.likes}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mt-2">
                <label htmlFor="comments" className="form-label">
                  Comments
                </label>
                <input
                  type="number"
                  id="comments"
                  className="form-control"
                  placeholder="Enter Comments"
                  value={formData.comments}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg-6 mt-2">
                <label htmlFor="clicks" className="form-label">
                  Clicks
                </label>
                <input
                  type="number"
                  id="clicks"
                  className="form-control"
                  placeholder="Enter Clicks"
                  value={formData.clicks}
                  onChange={handleChange}
                />
              </div>
            </>
          )}
        </div>

        {/* Action buttons */}
        <div className="hstack gap-2 mt-3 justify-content-start">
          <button type="submit" className="btn btn-success">
            Submit
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleReset}
          >
            Reset
          </button>
        </div>

        <ToastContainer />
      </div>
    </form>
  );
};

export default AddNewClients;
